module.exports = __webpack_public_path__ + "img/es.91221aeb.svg";